// extracted by mini-css-extract-plugin
export default {"fullscreenBottom":"dl_lQ","wrapper":"dl_dv","thumbnails":"dl_lR","thumbnail":"dl_lS","image":"dl_dy","isActive":"dl_f2"};